// helpers/usePageTracking.ts
import { useEffect, useState } from "react";
import { sendVisitLog } from "./visitLogger";
import { getSEODataList } from "./api/BlogService";

export function usePageTracking(pageName: string) {
    const [seoData, setSeoData] = useState<any>(null);

    useEffect(() => {
        // 1) Visit Log
        sendVisitLog(`/${pageName}`);

        // 2) SEO load
        const fetchSEO = async () => {
            try {
                const res = await getSEODataList();
                if (res?.result) {
                    const page = res.result.find((i: any) => i.pageName === pageName);
                    setSeoData(page || {});
                }
            } catch (err) {
                console.error("SEO load failed:", err);
            }
        };

        fetchSEO();
    }, [pageName]);

    return seoData;
}
